import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer/Footer';
import Header from "./Components/Header/Header.js"
import MainPg from './Components/MainPg/MainPg';
import Contact from "./Components/Contact/Contact"
import Work from "./Components/Work/Work"

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <div>
        <Header />
        <ScrollToTop /> {/* Added ScrollToTop component */}
        <Routes>
          <Route path="/contact" element={<Contact />} />
          <Route path="/work" element={<Work />} />
          <Route path="/" element={<MainPg />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
